import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { IValidationHandler, TValidatorError } from '../../model';
import { ValidationPatterns } from '../validation-patterns';

export function englishNameValidator(args: IValidationHandler): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const { value, invalid } = control;

    if (invalid) return null;

    if (!value) return null;

    const vldResponse: TValidatorError = { englishName: value };

    /** whitelist validation */
    const matchEngName = value.match(ValidationPatterns.englishName);

    if (!matchEngName?.length) {
      return vldResponse;
    }

    /** disallow 3 or more consecutive identical english chars */
    const matchConsecutive3 = value.match(ValidationPatterns.engConsecutive3);

    if (matchConsecutive3?.length) {
      return vldResponse;
    }

    /** disallow 2 consecutive identical english chars when value is only 2 chars long */
    if (value?.length === 2) {
      const matchConsecutive2 = value.match(ValidationPatterns.engConsecutive2);

      if (matchConsecutive2?.length) {
        return vldResponse;
      }
    }

    /** disallow entire value without vowels */
    const matchVowels = value.toUpperCase().match(ValidationPatterns.englishVowels);

    if (!matchVowels?.length) {
      return vldResponse;
    }

    return null;
  };
}
